export function isSkippedTriviaQuestion(
  skipRevealedQuestionIds: string[] | null | undefined,
  questionId: string | null | undefined,
): boolean {
  if (!questionId) return false;
  return (skipRevealedQuestionIds ?? []).includes(questionId);
}

export function triviaAdminShowsSkipReveal(
  status: string,
  skipped: boolean,
): boolean {
  if (skipped) return false;
  return status === 'QUESTION_CLOSED';
}

export function triviaAdminPrimaryLabel({
  status,
  skipped,
  last,
}: {
  status: string;
  skipped: boolean;
  last: boolean;
}): string | null {
  if (status === 'IDLE') {
    return 'Start round';
  }
  if (status === 'QUESTION_OPEN') {
    return 'Close answers';
  }
  if (status === 'QUESTION_CLOSED') {
    if (skipped) {
      return last ? 'Finish round' : 'Next question';
    }
    return 'Reveal answer';
  }
  if (status === 'REVEALED') {
    return last ? 'Finish round' : 'Next question';
  }
  return null;
}

export function triviaAdminQuestionListMark({
  index,
  currentIndex,
  skipped,
}: {
  index: number;
  currentIndex: number;
  skipped: boolean;
}): 'check' | 'current' | 'upcoming' {
  if (skipped || index < currentIndex) return 'check';
  if (index === currentIndex) return 'current';
  return 'upcoming';
}
